import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ThreadFilterService {
    dialogOpen$: Subject<any> = new Subject<any>();
}
